import { ace_index } from '@axo/shared/data-access/types';
import { useSearchQuery } from './useSearchQuery';

export function useCustomerHistory(
  {
    customerID,
    marketCountry,
    PageNumber = 1,
    PageSize = 20,
  }: {
    customerID: string;
    marketCountry: string;
    PageSize?: number;
    PageNumber?: number;
  },
  enabled = true
) {
  return useSearchQuery(
    {
      CustomerID: customerID,
      LoanApplicationMarketCountry: marketCountry,
      PaginationParameters: {
        PageNumber,
        PageSize,
      },
      Sort: {
        Order: ace_index.Order.Descending,
        SortBy: {
          Table: ace_index.SortByTable.LoanApplication,
          Column: 'UpdatedAt',
        },
      },
    },
    enabled
  );
}
